var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
//  External Components
import InputAdornment from "@mui/material/InputAdornment";
import makeStyles from "@mui/styles/makeStyles";
import TextField from "@mui/material/TextField";
// Icon
import SearchIcon from "@mui/icons-material/Search";
var useStyles = makeStyles(function (_a) {
    var pxToRem = _a.typography.pxToRem, background = _a.palette.background, spacing = _a.spacing;
    return ({
        underline: {
            "&::before": {
                borderBottom: "".concat(pxToRem(1), " solid ").concat(background.paper),
            },
        },
        inputSearch: {
            paddingRight: spacing(0.5),
            position: "absolute",
            right: 0,
        },
    });
});
export default (function (_a) {
    var error = _a.error, helperText = _a.helperText, required = _a.required, placeholder = _a.placeholder, label = _a.label, whiteTheme = _a.whiteTheme, startAdornment = _a.startAdornment, _b = _a.renderInputParams, InputProps = _b.InputProps, params = __rest(_b, ["InputProps"]), inputSearch = _a.inputSearch;
    var classes = useStyles();
    return (React.createElement(TextField, __assign({}, params, { InputProps: __assign(__assign(__assign(__assign({}, InputProps), (startAdornment && { startAdornment: startAdornment })), (inputSearch && {
            endAdornment: (React.createElement(InputAdornment, { position: "end", className: classes.inputSearch },
                React.createElement(SearchIcon, { fontSize: "small" }))),
        })), { classes: {
                underline: whiteTheme ? classes.underline : "none",
            } }), InputLabelProps: {
            required: required,
            shrink: true,
        }, label: label, placeholder: placeholder, error: error, helperText: helperText })));
});
//# sourceMappingURL=RenderInput.js.map